export const useClient = () => {
  const restaurantStore = useRestaurantStore()
  const { slug } = storeToRefs(restaurantStore)

  // Make sure we have the latest data from storage
  onMounted(() => {
    restaurantStore.getDataFromStorage()
  })

  function getPath() {
    const hostSlug = getRestaurantSlugFromHost()

    if (process.client && !hostSlug && !slug.value) {
      restaurantStore.getDataFromStorage()
    }

    const currentSlug = hostSlug || slug.value || ''

    if (currentSlug && slug.value !== currentSlug) {
      slug.value = currentSlug
    }

    if (currentSlug === 'wasabi') {
      return 'wasabi'
    }

    return 'ova-restaurant'
  }

  const getCurrentWeb = () => {
    return getPath();
  }

  const setBodyAttr = () => {
    // First, ensure we have the latest data
    if (process.client) {
      restaurantStore.getDataFromStorage()
    }

    const currentPath = getPath()

    // Apply the class directly to the document body for immediate effect
    if (process.client && document && document.body) {
      // Remove existing theme classes
      document.body.classList.remove('wasabi', 'ova-restaurant')
      // Add the current theme class
      document.body.classList.add(currentPath)
    }

    // Also use useHead for SSR compatibility
    // useHead({
    //   bodyAttrs: {
    //     class: currentPath,
    //   },
    // })
  }

  return { setBodyAttr, getCurrentWeb }
}
